import { render, staticRenderFns } from "./VehicleTipPanel.vue?vue&type=template&id=6584679e&scoped=true"
import script from "./VehicleTipPanel.vue?vue&type=script&lang=js"
export * from "./VehicleTipPanel.vue?vue&type=script&lang=js"
import style0 from "./VehicleTipPanel.vue?vue&type=style&index=0&id=6584679e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6584679e",
  null
  
)

export default component.exports